import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { routeByPath, GROUPS, groupHubs, servicesByGroup } from "@/data/routes";

const COLS = [
  { title: "Explore", links: ["/services", "/pricing", "/work", "/reviews", "/about", "/contact"] },
  { title: "Resources", links: ["/resources", "/guides", "/blog", "/faq", "/marketing-fit", "/speaking"] },
];

export const Footer = () => (
  <footer className="bliss-footer" data-testid="site-footer">
    <div className="bliss-container">
      <div className="bliss-footer-grid">
        <div className="bliss-footer-brand">
          <Logo />
          <p>
            Websites, advertising, search, content, and practical AI tools for businesses ready to
            grow. Led by Samantha, with specialists on the work.
          </p>
          <p className="bliss-mono">SAN DIEGO, CA · CLIENTS NATIONWIDE</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p className="bliss-mono bliss-footer-head">{c.title.toUpperCase()}</p>
            <ul>
              {c.links.map((p) => (
                <li key={p}>
                  <Link to={p} data-testid={`footer-link-${p.slice(1).replace(/\//g, "-")}`}>
                    {routeByPath[p].nav || routeByPath[p].h1}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <p className="bliss-mono bliss-footer-head">SERVICES</p>
          <ul>
            {Object.keys(GROUPS).map((g) => (
              <li key={g}>
                <Link to={groupHubs[g]}>{GROUPS[g]}</Link>
              </li>
            ))}
            <li><Link to="/services/google-ads">Google Ads</Link></li>
            <li><Link to="/services/wordpress">WordPress development</Link></li>
            <li><Link to="/services/ai-agents">AI agents</Link></li>
          </ul>
        </div>
      </div>
      <div className="bliss-footer-legal">
        <p>© {new Date().getFullYear()} Blissbranding Agency</p>
        <nav aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Service terms</Link>
          <Link to="/accessibility">Accessibility</Link>
        </nav>
      </div>
    </div>
  </footer>
);
